import { Icon } from "@trueskin-web/components"
import { starIcon } from "@trueskin-web/theme/icons/starIcon"

const StarRating = () => (
  <div
    sx={{
      mt: 4,
      display: "flex",
      alignItems: "center",
      columnGap: 2,
      justifyContent: "center",
      fontSize: 1,
      lineHeight: "smallerHeading",
    }}
  >
    4.7/5
    <span sx={{ display: "inline-flex", alignItems: "center" }}>
      {Array(5)
        .fill(undefined)
        .map((_, index) => (
          <Icon key={index} icon={starIcon} size="sm" />
        ))}
    </span>
    6.253+ Bewertungen
  </div>
)

export default StarRating
